
import { Component, Prop } from 'vue-property-decorator';
import { ActivitySettings } from '../../../backend/backendapi';
import Vue from 'vue';

@Component
export default class ActivitySettingsSwitch extends Vue {
  @Prop({ required: true })
  private activitySettings!: ActivitySettings;
  @Prop({ required: true })
  private property!: keyof ActivitySettings;
  
  get value(): boolean {
    return this.activitySettings[this.property] ?? false; //coalesce, prop may not be defined. e.g. was introduced later on
  }
  
  set value(value: boolean) {
    this.activitySettings[this.property] = value;
  }
}
